export default "__VITE_ASSET__9d765855__"